var map = {
	"./de.json": 111,
	"./en.json": 112,
	"./es.json": 113,
	"./fr.json": 114,
	"./ja.json": 115,
	"./ko.json": 116,
	"./pt-br.json": 117,
	"./ru.json": 118,
	"./zh.json": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;